import { imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import * as React from 'react';
import S from './ImageBanner.styles';
const ImageBanner = ({ images }) => {
    if (!images) {
        return null;
    }
    return (React.createElement("picture", null,
        React.createElement("source", { media: from(Device.TabletLarge), srcSet: imageUrl(images.desktop, { width: 1920 }) }),
        React.createElement("source", { media: from(Device.Tablet), srcSet: imageUrl(images.tablet, { width: 1024, height: 54 }) }),
        React.createElement(S.Image, { src: imageUrl(images.mobile, { width: 768 }), role: !images.mobile.altText ? 'presentation' : undefined, loading: "eager", alt: images.mobile.altText })));
};
export default ImageBanner;
